'use client';

import React from 'react';
import VendingMachineData from '@/vm/VendingMachineData';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';
import {
  DeviceContextProvider,
  type OwnProps as DeviceContextProps
} from '~/context/common/DeviceContext';
import {
  OwnProps as StaticContextProps,
  StaticContextProvider
} from '~/context/common/StaticContext';

export type VendingMachineProvidersProps = {
  forAnalyticsContext: {
    location?: { city: string; state: string };
  };
  forDeviceContext: DeviceContextProps;
  forStaticContext: StaticContextProps;
};

export type OwnProps = React.PropsWithChildren<
  VendingMachineProvidersProps & {
    eventableProject: string;
    eventableTrack: string;
  }
>;

function VendingMachineCommonProviders({
  children,
  eventableProject,
  eventableTrack,
  forAnalyticsContext,
  forDeviceContext,
  forStaticContext
}: OwnProps) {
  return (
    <StaticContextProvider {...forStaticContext}>
      <AnalyticsProvider
        projectName={eventableProject}
        track={eventableTrack}
        {...forAnalyticsContext}
      >
        <DeviceContextProvider {...forDeviceContext}>
          <VendingMachineData />
          {children}
        </DeviceContextProvider>
      </AnalyticsProvider>
    </StaticContextProvider>
  );
}

VendingMachineCommonProviders.displayName = 'VendingMachineCommonProviders';

export default VendingMachineCommonProviders;
